import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    cancel: string;
    delete: string;
    dropzone: string;
    label: string;
    save: string;
    select: string;
    invalidFiletypeError: (supportedTypes: string) => string | React.ReactNode;
    spinnerLabel: string;
};
export type Deps = {
    invalidFileTypeFragment: any;
};
export default {
    DEFINE(_messages: Text, { invalidFileTypeFragment }: Deps): void {
        return Object.defineProperties(this, {
            /** Cancel button label */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AvatarEditorDialog.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Delete image button label */
            delete: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AvatarEditorDialog.delete?c=3kcnwjyj3v5xn", defaultMessage: "Delete image" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dropzone instruction text */
            dropzone: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AvatarEditorDialog.dropzone?c=389yq3bds59mi", defaultMessage: "Drag and drop or click to upload image" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog label */
            label: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AvatarEditorDialog.label?c=2yyyovhhy1fjg", defaultMessage: "Edit image" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Save button label */
            save: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AvatarEditorDialog.save?c=1oof7q3mpz3f9", defaultMessage: "Save" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Select new image button label */
            select: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AvatarEditorDialog.select?c=19u2dcei6vt61", defaultMessage: "Select new image" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when invalid file type is uploaded */
            invalidFiletypeError: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (supportedTypes: string) => { const formattedTypes = invalidFileTypeFragment(supportedTypes); return __intl__.intl().formatMessage({ id: "AvatarEditorDialog.invalidFiletypeError.0?c=1zj92kp7y8zir", defaultMessage: "Upload failed. File must be one of the following types: {formattedTypes}" }, { formattedTypes: formattedTypes }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Loading spinner label */
            spinnerLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AvatarEditorDialog.spinnerLabel?c=33djl2b0m4hwj", defaultMessage: "Avatar Editor loading" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps: Deps): void;
};
